import Component from "gia/Component";
import Accordion from "accordion-js";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    //
    this.buildAccordions();

    this.events();
  }

  buildAccordions() {
    this.instanceAccordion = new Accordion(
      this.DOM.view.querySelector(".accordion-container")
    );
  }

  events() {}

  unmount() {
    this.instanceAccordion.destroy();
  }
}
